// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialList_root__3Hjaw","title":"SocialList_title___yI0g","list":"SocialList_list__7p_KN","item":"SocialList_item__4TNgw","icon":"SocialList_icon__ArKZQ"};